const initialState = {
  auth: false,
  authToken: '',
  account_id:null
};
export default initialState;
